<template>
  <div class="backgroud-white">
    <div class="backgroud-gray-popup popup-content-area-small text-center" v-loading="isLoading">
      <el-upload drag name="source_video" action :before-upload="beforeUpload" :on-change="onFileChange" ref="upload" :auto-upload="true"
        v-loading="isUploading" :element-loading-text="uploadingText" element-loading-spinner="el-icon-loading" :multiple="false" :disabled="uploadDisabled"
        :show-file-list="false" :class="{'cs-disabled':uploadDisabled}">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          <span v-if="type === 1">上传讲解视频</span>
          <span v-else>上传课节视频({{ dataIn.weekLabel }})</span>
        </div>
        <div class="el-upload__tip cs-upload-warning" slot="tip" v-if="isReplace">
          <span>该课节已上传视频</span>
          <span>上传时间: {{uploadTime}}</span>
        </div>
      </el-upload>
      <div>
        <div v-if="displayProgress" class="cs-upload-item">
          <div>
            <i class="el-icon-document"></i>
            <span>{{ fileData.name }}</span>
            <span>{{ fileSizeText }}</span>
            <span class="cs-color-green" v-if="fileData.successFlag">上传成功!</span>
          </div>
          <div>
            <el-progress :text-inside="true" :stroke-width="24" :percentage="fileData.progressPercent"></el-progress>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-left">
          <span v-if="!showError"></span>
          <el-alert :closable="false" v-if="showError" v-bind:title="errorMessage" type="error" show-icon></el-alert>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-right {
  float: right;
}
.cs-upload-warning {
  font-size: 1rem;
  font-weight: bold;
  span {
    display: block;
  }
}
.cs-upload-item {
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  span {
    display: inline-block;
    margin-left: 5px;

    &:first-of-type {
      margin-left: 1px;
    }
  }
}
.cs-disabled {
  pointer-events: none;

  /deep/ .el-upload {
    background-color: #d9d9d9;
  }
}
</style>

<script>
import {
  getAlibabaCloudConfigOption,
  getVodUploadSetting,
  getVodUploadSettingNonCA,
  refreshUploadVideo,
  saveAliyunVodResult,
  getAliyunVodVideoInfo,
  getAliyunVodVideoInfoByCA,
  getAliyunVodVideoInfoByVideoId,
} from "@/service/alibabaCloud.service";
import { saveClientSideError } from "../../service/common.service";
import { convertFileSize } from "../../config/mUtils";

export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 0,
      validator: (value) => [0, 1].contains(value),
    },
    dataIn: {
      courseActivationId: Number,
      weekLabel: String,
      courseId: Number,
      title: String,
      fileId: Number,
    },
  },
  data() {
    return {
      showError: false,
      errorMessage: "",
      submitBtnClass: "info",
      submitBtnDisable: true,
      isLoading: false,
      isUploadSuccess: false,
      isUploading: false,
      configOption: {},
      uploadingText: "",
      uploadTime: "",
      isReplace: false,
      uploadDisabled: false,
      displayProgress: false,
      fileData: {
        name: "",
        size: 0,
        progressPercent: 0,
        successFlag: false,
        videoId: null,
        lastModified: null,
      },
      extensions: [
        "asf",
        "avi",
        "divx",
        "dv",
        "dvx",
        "flv",
        "gvi",
        "m1pg",
        "m1v",
        "m21",
        "m2t",
        "m2ts",
        "m2v",
        "m4e",
        "m4u",
        "m4v",
        "mjp",
        "mod",
        "moov",
        "mov",
        "movie",
        "mp21",
        "mp3",
        "mp4",
        "mpe",
        "mpeg",
        "mpg",
        "mpv2",
        "mts",
        "qt",
        "qtch",
        "qtz",
        "rm",
        "rmvb",
        "rv",
        "svi",
        "swi",
        "tivo",
        "tod",
        "tp",
        "ts",
        "vfw",
        "vid",
        "vob",
        "vp6",
        "vp7",
        "wm",
        "wmv",
        "xvid",
        "yuv",
        "webm",
        "mxf",
        "ogv",
        "f4v",
        "mkv",
        "gif",
      ],
      fileTypeList: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    fileSizeText() {
      return convertFileSize(this.fileData.size);
    },
  },
  methods: {
    async getAlibabaCloudConfigOptionFromServer() {
      try {
        let result = await getAlibabaCloudConfigOption();
        if (!!result) {
          if (result.success) {
            this.configOption = result.data;
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getAliyunVodVideoInfoFromServer(fileId) {
      try {
        let result = await getAliyunVodVideoInfo(fileId);
        if (!!result) {
          if (result.success) {
            if (!!result.data) {
              this.isReplace = true;
              this.uploadTime = this.$moment
                .utc(result.data.CreateTime)
                .local()
                .format(`${this.GLOBAL.MomentDateFormatCHN} HH:mm`);
            } else {
              this.isReplace = false;
              this.uploadTime = "";
            }
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getAliyunVodVideoInfoByCAFromServer(courseActivationId) {
      try {
        let result = await getAliyunVodVideoInfoByCA(courseActivationId);
        if (!!result) {
          if (result.success) {
            if (!!result.data) {
              this.isReplace = true;
              this.uploadTime = this.$moment
                .utc(result.data.CreateTime)
                .local()
                .format(`${this.GLOBAL.MomentDateFormatCHN} HH:mm`);
            } else {
              this.isReplace = false;
              this.uploadTime = "";
            }
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async getAliyunVodVideoInfoByVideoIdFromServer(videoId) {
      try {
        let result = await getAliyunVodVideoInfoByVideoId(videoId);
        if (!!result && result.success) return result.data;
      } catch (error) {}

      return null;
    },
    async saveAliyunVodResultToServer(data) {
      try {
        let result = await saveAliyunVodResult(data);
        if (!!result && result.success) return result.data;
      } catch (error) {
        console.error(error);
      }

      return null;
    },
    async getVodUploadSettingFromServer(fileName, courseActivationId, lastModified) {
      try {
        let result = await getVodUploadSetting(
          fileName,
          courseActivationId,
          lastModified
        );
        if (!!result) {
          if (result.success) {
            return result.data;
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }

      return null;
    },
    async getVodUploadSettingNonCAFromServer(fileName, type, courseId, title, lastModified) {
      try {
        let result = await getVodUploadSettingNonCA(
          fileName,
          type,
          courseId,
          title,
          lastModified
        );
        if (!!result) {
          if (result.success) {
            return result.data;
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }

      return null;
    },
    async refreshUploadVideoFromServer(videoId) {
      try {
        let result = await refreshUploadVideo(videoId);
        if (!!result) {
          if (result.success) {
            return result.data;
          } else {
            this.$message.error(result.message);
          }
        }
      } catch (error) {
        this.$message.error(error.message);
      }

      return null;
    },

    async init(isInitial = true) {
      this.getSupportedFileTypeList();

      this.uploadDisabled = false;
      (this.displayProgress = false),
        (this.fileData = {
          name: "",
          size: 0,
          progressPercent: 0,
          successFlag: false,
        });

      this.isLoading = true;

      if (isInitial) {
        await this.getAlibabaCloudConfigOptionFromServer();
        this.uploader = await this.createUploader();
      }

      if (!!this.dataIn) {
        if (
          this.type === this.GLOBAL.enumVideoType.Email &&
          !this.dataIn.courseActivationId
        ) {
          await this.getAliyunVodVideoInfoFromServer(this.dataIn.fileId);
        } else {
          await this.getAliyunVodVideoInfoByCAFromServer(
            this.dataIn.courseActivationId
          );
        }
      }

      this.isLoading = false;
    },
    getSupportedFileTypeList() {
      this.fileTypeList = File.convertToFileTypeList(this.extensions);
    },
    createUploader() {
      const _self = this;
      let vodConfig = this.configOption.VodConfigs.find(i => i.IsDefault);
      let uploader = new AliyunUpload.Vod({
        // userID，用于标识上传者的身份，必填，有值即可，可以是阿里云账号ID或者您自定义的用户ID，您可以访问阿里云账号中心（https://account.console.aliyun.com/）查看账号ID
        userId: this.configOption.UserId,
        // 上传到视频点播的地域，默认值为"us-west-1"，
        region: vodConfig.RegionId, //'cn-shanghai',
        // 分片大小默认1 MB，不能小于100 KB（100*1024）
        partSize: 1 * 1024 * 1024,
        // 并行上传分片个数，默认5
        parallel: 5,
        // 网络原因失败时，重新上传次数，默认为3
        retryCount: 3,
        // 网络原因失败时，重新上传间隔时间，默认为2秒
        retryDuration: 2,
        localCheckpoint: true, //此参数是禁用服务端缓存，不影响断点续传
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {},
        // 开始上传
        onUploadstarted: async function (uploadInfo) {
          await _self.onAliyunVodUploadStarted(uploadInfo);
        },
        // 文件上传成功
        onUploadSucceed: async function (uploadInfo) {
          await _self.onAliyunVodUploadSucceed(uploadInfo);
        },
        // 文件上传失败
        onUploadFailed: async function (uploadInfo, code, message) {
          await _self.onAliyunVodUploadFailed(uploadInfo, code, message);
        },
        // 文件上传进度，单位：字节
        onUploadProgress: async function (
          uploadInfo,
          totalSize,
          loadedPercent
        ) {
          await _self.onAliyunVodUploadProgress(
            uploadInfo,
            totalSize,
            loadedPercent
          );
        },
        // 上传凭证或STS token超时
        onUploadTokenExpired: async function (uploadInfo) {
          await _self.onAliyunVodUploadTokenExpired(uploadInfo);
        },
        // 全部文件上传结束
        onUploadEnd: async function (uploadInfo) {
          await _self.onAliyunVodUploadEnd(uploadInfo);
        },
      });

      return uploader;
    },
    onFileChange() {},
    beforeUpload(file) {
      if (file.size > 1024 * 1024 * 1024 * 10) {
        this.showError = true;
        this.errorMessage = `文件 ${file.name} 大小超出限制（10G）`;
        return false;
      }

      let fileType = file.getMimeType();
      if (this.fileTypeList.indexOf(fileType) < 0) {
        this.showError = true;
        this.errorMessage = `文件格式${fileType}错误`;
        return false;
      }

      this.clearMessages();
      this.isUploadSuccess = false;

      this.uploadingText =
        "正在上传视频" + file.name + "。上传过程中，文件上传窗口无法关闭。";

      this.fileData = {
        name: file.name,
        size: file.size,
        progressPercent: 0,
        successFlag: false,
        videoId: null,
        lastModified: file.lastModified || (file.raw && file.raw.lastModified) || null,
      };
      (this.displayProgress = true), (this.isUploading = true);
      this.$emit("beforeUpload");

      this.uploader.addFile(file, null, null, null, null);
      this.uploader.startUpload();

      return false;
    },
    async onAliyunVodUploadStarted(uploadInfo) {
      // console.log("onAliyunVodUploadStarted: ", uploadInfo, this.type, this.dataIn);

      if (!uploadInfo.videoId) {
        let resData;
        switch (this.type) {
          case 1:
            resData = await this.getVodUploadSettingNonCAFromServer(
              uploadInfo.file.name,
              this.type,
              this.dataIn.courseId,
              this.dataIn.title,
              this.fileData.lastModified
            );
            break;
          default:
            resData = await this.getVodUploadSettingFromServer(
              uploadInfo.file.name,
              this.dataIn.courseActivationId,
              this.fileData.lastModified
            );
            break;
        }
        if (!!resData) {
          let uploadAuth = resData.UploadAuth;
          let uploadAddress = resData.UploadAddress;
          this.fileData.videoId = resData.VideoId;
          this.uploader.setUploadAuthAndAddress(
            uploadInfo,
            uploadAuth,
            uploadAddress,
            this.fileData.videoId
          );
        }
      } else {
        let resData = await this.refreshUploadVideoFromServer(
          uploadInfo.videoId
        );
        if (!!resData) {
          let uploadAuth = resData.UploadAuth;
          let uploadAddress = resData.UploadAddress;
          let videoId = resData.VideoId;
          this.uploader.setUploadAuthAndAddress(
            uploadInfo,
            uploadAuth,
            uploadAddress,
            videoId
          );
        }
      }
    },
    async onAliyunVodUploadSucceed(uploadInfo) {
      // console.log("onAliyunVodUploadSucceed: ", uploadInfo);
      this.fileData.progressPercent = 99;
      this.isUploadSuccess = true;
      this.submitBtnClass = "info";
      this.clearMessages();
      this.$refs.upload.clearFiles();
      this.$emit("fileUploaded");

      let fileName = uploadInfo.file.name;
      let paramsData = {
        Type: this.type,
        CourseActivationId: this.dataIn.courseActivationId,
        CourseId: this.dataIn.courseId,
        VideoId: uploadInfo.videoId,
        SourceFileName: uploadInfo.file.name,
        FileSize: uploadInfo.file.size,
        SourceFileDate: this.fileData.lastModified
          ? new Date(this.fileData.lastModified).toISOString()
          : null,
        Title: this.dataIn.title || "",
        Description: this.dataIn.title,
        RegionId: uploadInfo.region,
      };
      let id = await this.saveAliyunVodResultToServer(paramsData);

      this.$emit("success", fileName, this.dataIn.courseActivationId, id);
    },
    async onAliyunVodUploadFailed(uploadInfo, code, message) {
      this.isUploadSuccess = false;
      this.showError = true;
      try {
        saveClientSideError("AliyunVod上传出错", message);
      } catch (e) {}
      this.errorMessage = "上传出错";
      this.$emit("fileUploadError");
    },
    async onAliyunVodUploadProgress(uploadInfo, totalSize, loadedPercent) {
      let value = loadedPercent * 100;
      let percent = parseInt(value);
      if (percent > 99) {
        percent = 99;
      }

      this.fileData.progressPercent = percent;
    },
    async onAliyunVodUploadTokenExpired(uploadInfo) {
      let resData = await this.refreshUploadVideoFromServer(uploadInfo.videoId);
      if (!!resData) {
        let uploadAuth = resData.UploadAuth;
        this.uploader.resumeUploadWithAuth(uploadAuth);
      }
    },
    async onAliyunVodUploadEnd(uploadInfo) {
      this.fileData.successFlag = true;
      this.fileData.progressPercent = 100;
      this.isUploading = false;
      this.uploadDisabled = true;
    },
    clearMessages() {
      this.showError = false;
      this.errorMessage = "";
    },
  },
  watch: {
    dataIn: function () {
      this.init(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/aliyunVod/videoUpload.vue